import { styled } from 'styled-components'

const getBorderColor = (isValid) => {
  let color = 'var(--silver)'
  if (isValid === true) {
    color = 'var(--green-border)'
  } else if (isValid === false) {
    color = 'var(--red-message)'
  }
  return color
}

export const Container = styled.div`
  position: relative;
`

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
  text-align: left;
  position: relative;
  input {
    background-color: var(--white);
    border: 1px solid;
    border-color: ${({ isValid }) => getBorderColor(isValid)};
    box-shadow: none;
    box-sizing: border-box;
    font-family: var(--fontRegular);
    font-size: 17px;
    height: 45px;
    margin-top: 6px;
    padding: 0 9px;
    width: 100%;
    :focus {
      border: none;
      outline: solid 1px;
      outline-color: ${({ isValid }) =>
        isValid === null ? 'var(--orange)' : getBorderColor(isValid)};
    }
    :disabled {
      background: var(--disabled);
      border: 1px solid var(--silver);
      color: var(--dark-gray);
    }
  }
`

export const Wrapper = styled.div`
  align-items: center;
  bottom: 0;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
  height: 45px;
  justify-content: center;
  position: absolute;
  right: 10px;
`

export const Message = styled.p`
  color: var(--red-message);
  font-family: var(--fontRegular);
  font-size: 14px;
  padding-top: 8px;
`

export const CheckBox = styled.label`
  align-items: center;
  display: flex;
  position: absolute;
  right: 12px;
  top: 36px;
  input {
    height: 15px;
    width: 15px;
    :disabled {
      background: var(--disabled);
      border: 1px solid var(--silver);
      & ~ span {
        color: var(--dark-gray);
      }
    }
  }
  span {
    font-family: var(--fontRegular);
    font-size: 13px;
    user-select: none;
  }
`

export const BoxTooltip = styled.div`
  /* WIP: Tooltip component */
  border: solid;
`

export const Loader = styled.div`
  animation: spin 1s ease infinite;
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: var(--orange);
  border-radius: 50%;
  height: 20px;
  width: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`
